import { IApplicationState } from '../types/redux';
import { isSpecialIntoCase } from '../utils/isSpecialIntoCase';

export const selectWithIntroScreen =
  (isDesktop: boolean) =>
  ({ page: { intro } }: IApplicationState) => {
    return isSpecialIntoCase(intro) ? true : !isDesktop;
  };
